// extracted by mini-css-extract-plugin
export default {"container":"EditBlog_container__grE0U"};